import {Body, Footer, FooterItem, Header} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import {Separator} from "@zendeskgarden/react-dropdowns";
import {FileUploadModalProps} from "./FileUploadModalProps";
import {ReactElement} from "react";
import {FileUploadModalStates} from "./FileUploadModalStates";
import {DirectCoAActualsButton} from "./csvbox/DirectCoAActualsButton";

export function ChooseCoA(props: FileUploadModalProps): ReactElement {
    return <>
        <Header>Choose Chart of Accounts Method</Header>
        <Body>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                <div>
                    {/*<Button onClick={() => props.setState(FileUploadModalStates.UPLOAD_DIRECT_COA_FILES)}>Use Property Chart of Accounts</Button>*/}
                    <DirectCoAActualsButton propertyId={props.propertyId} jobCreated={(jobId, propertyId) => {
                        props.jobCreated(jobId, propertyId);
                        props.onModalClose();
                    }} />
                </div>
                <div style={{margin: "0.5em 0"}}>-or-</div>
                <div>
                    <Button onClick={() => props.setState(FileUploadModalStates.CHOOSE_EXTERNAL_COA)}>Use Existing Custom Chart of Accounts</Button>
                </div>
                <div style={{margin: "0.5em 0"}}>-or-</div>
                <div>
                    <Button onClick={() => props.setState(FileUploadModalStates.CREATE_NEW_COA)}>Create Custom Chart of Accounts</Button>
                </div>
            </div>
        </Body>
        <Separator />
        <Footer>
            <FooterItem>
                <Button onClick={props.onModalClose} isBasic>
                    Cancel
                </Button>
            </FooterItem>
        </Footer>
    </>;
}